import React, { createContext, useState, useContext, ReactNode, useCallback } from 'react';
import { AlertDialog } from '../components/AlertDialog';

interface AlertContextType {
  alert: (message: string) => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const [alertMessage, setAlertMessage] = useState<string | null>(null);

  const alert = useCallback((message: string) => {
    setAlertMessage(message);
  }, []);

  const handleClose = () => {
    setAlertMessage(null);
  };

  return (
    <AlertContext.Provider value={{ alert }}>
      {children}
      {alertMessage && <AlertDialog message={alertMessage} onClose={handleClose} />}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};